import { BoundaryProvider } from "../../context/boundary/BoundaryProvider";
import { ThemeProvider } from "../../context/theme";
import { MapProvider } from "../../context/map";

interface AppProvidersProps {
  children: React.ReactNode;
}

export const AppProviders = ({ children }: AppProvidersProps) => {
  return (
    <ThemeProvider>
      <BoundaryProvider>
        <MapProvider>{children}</MapProvider>
      </BoundaryProvider>
    </ThemeProvider>
  );
};
